import { render, staticRenderFns } from "./PaymentMenu.vue?vue&type=template&id=15a53dd8"
import script from "./PaymentMenu.vue?vue&type=script&lang=js"
export * from "./PaymentMenu.vue?vue&type=script&lang=js"
import style0 from "./PaymentMenu.vue?vue&type=style&index=0&id=15a53dd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports